import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  errorText: {
    color: theme.palette.error.main,
  },
}))

export default styles
